(function () {
  'use strict';

  function readImages() {
    var el = document.getElementById('cg-gallery-data');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  var CgGallery = {
    images: [],
    root: null,

    build: function () {
      if (this.root) return this.root;
      var root = document.createElement('div');
      root.className = 'cg-gal';
      root.hidden = true;

      var bar = document.createElement('div');
      bar.className = 'cg-gal__bar';
      var title = document.createElement('p');
      title.className = 'cg-gal__title';
      title.textContent = 'Product gallery';
      var close = document.createElement('button');
      close.className = 'cg-gal__close';
      close.type = 'button';
      close.setAttribute('aria-label', 'Close gallery');
      close.textContent = '×';
      bar.appendChild(title);
      bar.appendChild(close);

      var scroll = document.createElement('div');
      scroll.className = 'cg-gal__scroll';

      this.images.forEach(function (img, i) {
        var wrap = document.createElement('div');
        wrap.className = 'cg-gal__item';
        wrap.dataset.index = String(i);
        var el = document.createElement('img');
        el.className = 'cg-gal__img';
        el.src = img.src;
        el.alt = img.alt || '';
        el.loading = i < 2 ? 'eager' : 'lazy';
        if (img.width) el.width = img.width;
        if (img.height) el.height = img.height;
        wrap.appendChild(el);
        scroll.appendChild(wrap);
      });

      root.appendChild(bar);
      root.appendChild(scroll);
      document.body.appendChild(root);

      close.addEventListener('click', this.close.bind(this));
      scroll.addEventListener('click', this.onTap.bind(this));

      this.root = root;
      this.scroll = scroll;
      return root;
    },

    onTap: function (e) {
      var img = e.target.closest('.cg-gal__img');
      if (!img) return;
      var now = Date.now();
      if (this._lastTap && now - this._lastTap < 320) {
        if (img.classList.contains('is-zoomed')) {
          img.classList.remove('is-zoomed');
          img.style.transformOrigin = '';
        } else {
          var rect = img.getBoundingClientRect();
          var ox = rect.width ? ((e.clientX - rect.left) / rect.width) * 100 : 50;
          var oy = rect.height ? ((e.clientY - rect.top) / rect.height) * 100 : 50;
          ox = Math.max(0, Math.min(100, ox));
          oy = Math.max(0, Math.min(100, oy));
          img.style.transformOrigin = ox + '% ' + oy + '%';
          img.classList.add('is-zoomed');
        }
        this._lastTap = 0;
      } else {
        this._lastTap = now;
      }
    },

    // Tra chi so anh theo MA MEDIA thay vi theo vi tri thu tu.
    // Ly do: danh sach anh trong JSON loc bang Liquid (media_type == 'image'),
    // con cac o anh trong DOM loc bang class. Neu san pham co video/3D ma hai
    // bo loc lech nhau mot phan tu thi cham anh nay se mo ra anh khac. Ghep
    // theo ma media thi thu tu va bo loc khong con quan trong nua.
    openByMediaId: function (mediaId) {
      // Nho phan tu vua kich hoat de tra focus ve dung cho khi dong overlay.
      this._trigger = document.activeElement;
      var idx = -1;
      for (var i = 0; i < this.images.length; i++) {
        if (String(this.images[i].id) === String(mediaId)) { idx = i; break; }
      }
      this.open(idx < 0 ? 0 : idx);
    },

    open: function (index) {
      this.build();
      this.root.hidden = false;
      document.body.classList.add('cg-gal-open');
      // Eager-load the opened image and its immediate neighbours so jumping
      // straight to a lazy image doesn't show a blank screen while it downloads.
      for (var d = -1; d <= 1; d++) {
        var neighbour = this.scroll.querySelector('[data-index="' + (index + d) + '"]');
        if (neighbour) {
          var nImg = neighbour.querySelector('img');
          if (nImg) nImg.loading = 'eager';
        }
      }
      var target = this.scroll.querySelector('[data-index="' + index + '"]');
      if (target) this.scroll.scrollTop = target.offsetTop;
      if (!this._popped) {
        history.pushState({ cgGallery: true }, '');
        this._popped = true;
      }
      // Dua focus vao nut dong de nguoi dung ban phim khong bi ket ngoai overlay.
      var closeBtn = this.root.querySelector('.cg-gal__close');
      if (closeBtn) closeBtn.focus();
    },

    close: function () {
      if (!this.root || this.root.hidden) return;
      this.root.hidden = true;
      document.body.classList.remove('cg-gal-open');
      this.scroll.querySelectorAll('.is-zoomed').forEach(function (n) {
        n.classList.remove('is-zoomed');
        n.style.transformOrigin = '';
      });
      if (this._popped) {
        this._popped = false;
        history.back();
      }
      // Tra focus ve dung anh vua mo, thay vi de focus roi ve dau trang.
      if (this._trigger && typeof this._trigger.focus === 'function') {
        this._trigger.focus();
      }
    }
  };

  function init() {
    CgGallery.images = readImages();
    if (!CgGallery.images.length) return;

    // Capture phase + stop(Immediate)Propagation: the theme's own PhotoSwipe
    // click handler lives on/under the same wrapper elements. Intercepting on
    // document during capture (before the event ever reaches the wrapper's
    // own bubble-phase listeners) and stopping propagation there prevents the
    // theme's horizontal lightbox from opening underneath ours.
    document.addEventListener('click', function (e) {
      var media = e.target.closest('[data-cg-gallery-open]');
      if (!media) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      CgGallery.openByMediaId(media.dataset.cgGalleryOpen);
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') CgGallery.close();
    });

    // Mo gallery bang ban phim. Cac o anh la <div> nen khong tu nhan Enter/Space
    // nhu <button>; phai tu xu ly. Khong lam viec nay thi nguoi dung ban phim
    // KHONG CACH NAO mo duoc gallery (loi WCAG 2.1.1).
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var media = e.target.closest('[data-cg-gallery-open]');
      if (!media) return;
      e.preventDefault();
      CgGallery.openByMediaId(media.dataset.cgGalleryOpen);
    });

    window.addEventListener('popstate', function () {
      if (CgGallery.root && !CgGallery.root.hidden) {
        CgGallery._popped = false;
        CgGallery.close();
      }
    });

    window.CgGallery = CgGallery;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ---- Desktop hover zoom ----
  function initMagnifier() {
    var mediaQuery = window.matchMedia('(min-width:1025px) and (pointer:fine)');
    // KHONG return som khi man hinh dang hep. Neu return o day thi listener
    // khong bao gio duoc gan, va nguoi dung mo rong cua so hay xoay tablet sang
    // ngang se khong bao gio co kinh lup. Viec bat/tat nam trong isDesktopMode()
    // duoc goi lai trong show() va move().
    var images = readImages();
    if (!images.length) return;

    var stage = document.querySelector('.product__media-list, .product-media-list');
    if (!stage) return;
    var host = stage.parentElement;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var lens = document.createElement('div');
    lens.className = 'cg-zoom-lens';
    var pane = document.createElement('div');
    pane.className = 'cg-zoom-pane';
    host.appendChild(lens);
    host.appendChild(pane);

    var ZOOM = 2.5;
    var active = null;

    function isDesktopMode() {
      return mediaQuery.matches;
    }

    function show(img) {
      if (!isDesktopMode()) {
        hide();
        return;
      }

      var r = img.getBoundingClientRect();
      var hostR = host.getBoundingClientRect();
      pane.style.width = r.width + 'px';
      pane.style.height = r.height + 'px';
      pane.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
      pane.style.backgroundSize = (r.width * ZOOM) + 'px ' + (r.height * ZOOM) + 'px';
      pane.style.top = (r.top - hostR.top) + 'px';

      // PHONG TO NGAY TREN ANH, khong dat khung ben canh.
      // Ly do doi: dat ben canh (kieu Amazon PC) thi khung rong bang ca buc anh
      // nen DE LEN toan bo cot mua hang - che ca nut ADD TO CART trong luc re
      // chuot. Founder thay kho chiu. Dat trung khit vi tri anh thi khong con
      // gi che cot mua hang, va cung khong con van de xep lop giua hai cot.
      pane.style.left = (r.left - hostR.left) + 'px';
      pane.style.display = 'block';
      // Khong dung kinh lup nho nua: ca khung zoom da nam dung tren anh roi.
      lens.style.display = 'none';
      active = img;
    }

    function hide() {
      pane.style.display = 'none';
      lens.style.display = 'none';
      active = null;
    }

    function move(e) {
      if (!active) return;
      if (!isDesktopMode()) {
        hide();
        return;
      }

      var r = active.getBoundingClientRect();
      var x = Math.min(Math.max(e.clientX - r.left, 0), r.width);
      var y = Math.min(Math.max(e.clientY - r.top, 0), r.height);
      pane.style.backgroundPosition = '-' + (x * ZOOM - r.width / 2) + 'px -' + (y * ZOOM - r.height / 2) + 'px';
    }

    stage.addEventListener('mouseover', function (e) {
      var img = e.target.closest('img');
      if (img) show(img);
    });
    stage.addEventListener('mousemove', move);
    stage.addEventListener('mouseleave', hide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMagnifier);
  } else {
    initMagnifier();
  }
})();
